/**
 * Internal staff RMA list — the full unscoped view of all RMAs across
 * every customer and site group.
 *
 * Renders the ReturnGrid in its "internal" variant. Staff can scope by
 * customer / site group via the scope-search chips, and filter by RMA
 * status and workflow toggles (Quick Ship, Ready to Invoice, Needs Photo).
 */
import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';

import ReturnGrid from './components/ReturnGrid';

export default function InternalReturnGridView({ loading, ...props }) {
  const { t } = useTranslation();
  return (
    <AppNav flex notFullHeight loading={loading} page="returns_rmas" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar breadcrumbs={[{ label: t('support.rmaList', 'RMAs') }]} />
        <ReturnGrid variant="internal" />
      </Box>
    </AppNav>
  );
}
